"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _tag = _interopRequireDefault(require("./tag.proptypes"));
var _constant = require("./constant");
var _Link = _interopRequireDefault(require("../Link"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var TagContainer = _styledComponents.default.div.withConfig({
  displayName: "Tag__TagContainer",
  componentId: "sc-a23gne-0"
})(["display:", ";font-weight:", ";font-family:", ";font-size:", ";background:", ";border-radius:", ";text-decoration:", ";text-align:", ";margin:", ";padding:", ";line-height:", ";"], function (_ref) {
  var display = _ref.display;
  return display;
}, function (_ref2) {
  var bold = _ref2.bold,
    theme = _ref2.theme;
  return bold ? theme.fontWeight.bold : theme.fontWeight.normal;
}, function (_ref3) {
  var theme = _ref3.theme;
  return "".concat(theme.fontFamily.default, ", Roboto");
}, function (_ref4) {
  var theme = _ref4.theme,
    type = _ref4.type;
  return theme.fontSize[_constant.TEXT_TYPE[type] ? _constant.TEXT_TYPE[type].size : _constant.TEXT_TYPE.default.size];
}, function (_ref5) {
  var backgroundColor = _ref5.backgroundColor,
    theme = _ref5.theme;
  return backgroundColor ? theme.backgroundColor[backgroundColor] : theme.backgroundColor.default;
}, function (_ref6) {
  var borderRadius = _ref6.borderRadius,
    theme = _ref6.theme;
  return borderRadius || theme.borderRadius.normal;
}, 'none', function (_ref7) {
  var textAlign = _ref7.textAlign;
  return textAlign || 'initial';
}, function (_ref8) {
  var margin = _ref8.margin;
  return margin || '5px 5px 0 0';
}, function (_ref9) {
  var padding = _ref9.padding;
  return padding || '2px 12px';
}, function (_ref10) {
  var theme = _ref10.theme,
    type = _ref10.type;
  return _constant.TEXT_TYPE[type] && theme.lineHeight ? theme.lineHeight[_constant.TEXT_TYPE[type].lineHeight] : '0px';
});
var Tag = function Tag(props) {
  var accessible = props.accessible,
    type = props.type,
    theme = props.theme,
    target = props.target,
    bold = props.bold,
    color = props.color,
    backgroundColor = props.backgroundColor,
    borderRadius = props.borderRadius,
    margin = props.margin,
    padding = props.padding,
    textAlign = props.textAlign,
    customProperties = props.customProperties,
    children = props.children,
    href = props.href,
    display = props.display,
    handleOnClick = props.handleOnClick,
    clickable = props.clickable;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  // eslint-disable-next-line consistent-return
  var handleClick = function handleClick(e) {
    e.stopPropagation();
    if (handleOnClick) {
      e.preventDefault();
      return handleOnClick();
    }
  };
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(_Link.default, {
      accessible: accessible,
      href: href,
      target: target || 'tab',
      color: color,
      hoverUnderlined: false,
      clickable: clickable
    }, /*#__PURE__*/_react.default.createElement(TagContainer, (0, _extends2.default)({
      display: _constant.DISPLAY[display],
      type: type,
      bold: bold,
      backgroundColor: backgroundColor,
      borderRadius: borderRadius,
      margin: margin,
      padding: padding,
      textAlign: textAlign,
      theme: themeContext,
      onClick: handleClick
    }, customProperties), children));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
Tag.propTypes = _tag.default.PropTypes;
Tag.defaultProps = _tag.default.DefaultProps;
var _default = Tag;
exports.default = _default;